import * as React from 'react';

import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import {
    BerthAssignmentDetailsActionsTab as ActionsTab,
    CancelReservationAction,
    RaftReservationAction
} from './actions';

import { ListErrors } from 'core/validationerror/view';

export const BerthAssignmentDetailsActionsTabView = SuperCritical(({ model: m } : { model : ActionsTab }) =>
    <div className="berthassignmentdetailsactionstab">
        <div className="ccard-details-actions-tab__section ccard-details-actions-tab__coordination-actions-shell">
            <div className="ccard-details-actions-tab__section-title">Reservation Actions</div>
            <CancelReservationActionView action={m.CancelReservation} />
            <RaftReservationActionView action={m.RaftReservation} />
        </div>
    </div>
);

const CancelReservationActionView = SuperCritical(({ action } : { action : CancelReservationAction }) =>
    action.IsAvailable() ?
        <div className="ccard-details-actions-tab__coordination-action cancel-reservation-action">
            <div className="coordination-action-link-shell">
                <a
                    href=""
                    className="coordination-action-link"
                    onClick={noDefault(() => action.IsSelected(true))}
                >
                    Cancel this Reservation
                </a>
            </div>
            {action.IsSelected() ?
                // TODO: Some designs show this spawning a modal popup like the old cancel reservation popup
                // instead. Do we go that route? If so, we should think about whether we wanna instantiate that
                // modal here directly or put that responsibility calling code instead, for more flexibility
                // over things like z-index.
                <div className="cancellation-action-shell">
                    <div className="remarks-shell">
                        <textarea
                            className="remarks"
                            value={action.Req()?.Remarks() ?? ''}
                            onChange={e => action.Req()?.Remarks(e.currentTarget.value || null)}
                            placeholder="These remarks will be sent to editors on this PortCall."
                        />
                    </div>
                    <div className="pc-confirm">
                        <span className="pc-confirm-question">
                            <b>
                                Are you sure you want to cancel this
                                {action.BerthReservation.Itinerary()?.Location() ?
                                    ` reservation for ${action.BerthReservation.Itinerary()!.Location()!.Name()}?` :
                                    ' reservation?'
                                }
                            </b>
                        </span>
                        <button
                            className="pc-confirm-button pc-confirm-button-primary"
                            onClick={action.Perform}
                            disabled={action.IsPerforming()}
                        >
                            Yup
                        </button>
                        <button
                            className="pc-confirm-button"
                            onClick={() => action.IsSelected(false)}
                            disabled={action.IsPerforming()}
                        >
                            Nope
                        </button>
                    </div>
                </div> :
                <div className="coordination-action-description">
                    Cancel this reservation and all coordinations to and from this location.
                </div>
            }
        </div> :
        null
);

const RaftReservationActionView = SuperCritical(({ action } : { action : RaftReservationAction }) =>
    action.IsAvailable() ?
        <div className="ccard-details-actions-tab__coordination-action raft-reservation-action">
            <div className="coordination-action-link-shell">
                <a
                    href=""
                    className="coordination-action-link"
                    // TODO: Do we want a confirm workflow for rafting/unrafting like we have for other actions?
                    // For now, thinking of rafting/unrafting as fairly "light" edits, so no need to confirm.
                    // Then again, rafting/unrafting can add/remove conflicts, thus triggering emails....
                    onClick={noDefault(action.ToggleRafting)}
                >
                    {action.Persisted.Rafting() ? 'Stop Rafting this Reservation' : 'Raft this Reservation'}
                </a>
            </div>
            <div className="coordination-action-description">
                Raft this reservation to indicate its position at the berth as not directly resting on the berth.
            </div>
            {/* Unrafting could in theory trigger agent restrictions by creating new overlap conflicts. In
            practice that can't happen b/c only berth mgrs and above can edit rafting and agent restrictions
            don't apply to them. So this is just future-proofing in case we someday change any of those
            permissions. */}
            {ListErrors(action.Validation())}
        </div> :
        null
);



// WEBPACK FOOTER //
// ./apps/portcall/berthassignmentdetails/actionsview.tsx